import React, { memo } from 'react'
import styles from './ListItem.module.scss'

type Props = {
    item?: any
    onItemClickHandler?: (item: any) => any
    buttonTitle?: string
    onButtonHandler?: (item: any) => void
}

const ListItem: React.FC<Props> = memo((props: Props) => {


    const handleButtonClick = (event: any) => {
        // Prevent the click event from propagating to the parent div
        const ev = event as MouseEvent;

        ev.stopPropagation();

        // Call the button click handler
        if (props.onButtonHandler != null) props.onButtonHandler(props.item) ;
    };


    return (
        <div className={styles.item} onClick={() => props.onItemClickHandler!(props.item)}>
            <div className={styles.left}>
                <div className={styles.img}>
                    <svg width="20px" height="20px" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99997 9.14021C7.87707 9.14021 6.9158 8.7404 6.11615 7.94076C5.31649 7.14111 4.91667 6.17983 4.91667 5.05694C4.91667 3.93402 5.31649 2.97275 6.11615 2.17311C6.9158 1.37346 7.87707 0.973633 8.99997 0.973633C10.1229 0.973633 11.0841 1.37346 11.8838 2.17311C12.6834 2.97275 13.0833 3.93402 13.0833 5.05694C13.0833 6.17983 12.6834 7.14111 11.8838 7.94076C11.0841 8.7404 10.1229 9.14021 8.99997 9.14021ZM0.25 18.0248V15.4313C0.25 14.8599 0.405186 14.3308 0.715558 13.844C1.02591 13.3571 1.44059 12.9828 1.9596 12.721C3.11281 12.1556 4.27612 11.7316 5.44951 11.4489C6.62291 11.1662 7.80639 11.0249 8.99997 11.0249C10.1935 11.0249 11.377 11.1662 12.5504 11.4489C13.7238 11.7316 14.8871 12.1556 16.0403 12.721C16.5593 12.9828 16.974 13.3571 17.2844 13.844C17.5948 14.3308 17.7499 14.8599 17.7499 15.4313V18.0248H0.25ZM1.99997 16.2748H16V15.4313C16 15.1949 15.9315 14.9762 15.7947 14.775C15.6578 14.5738 15.472 14.4097 15.2371 14.2825C14.232 13.7875 13.2071 13.4124 12.1625 13.1574C11.1178 12.9024 10.0636 12.7748 8.99997 12.7748C7.93632 12.7748 6.88216 12.9024 5.83749 13.1574C4.79281 13.4124 3.76792 13.7875 2.7628 14.2825C2.52796 14.4097 2.34212 14.5738 2.20527 14.775C2.06841 14.9762 1.99997 15.1949 1.99997 15.4313V16.2748ZM8.99997 7.39027C9.64164 7.39027 10.1909 7.1618 10.6479 6.70485C11.1048 6.24791 11.3333 5.6986 11.3333 5.05694C11.3333 4.41527 11.1048 3.86597 10.6479 3.40902C10.1909 2.95208 9.64164 2.7236 8.99997 2.7236C8.3583 2.7236 7.809 2.95208 7.35205 3.40902C6.89511 3.86597 6.66664 4.41527 6.66664 5.05694C6.66664 5.6986 6.89511 6.24791 7.35205 6.70485C7.809 7.1618 8.3583 7.39027 8.99997 7.39027Z" fill="#1C1B1F" />
                    </svg>
                </div>
                <div className={styles.title}>
                    {`${props.item.firstName} ${props.item.lastName}`}
                </div>
                <div className={styles.tag}>
                    {props.item.type}
                </div>
            </div>

            <button className={`standardButton ${styles.rightButton} ${props.item.type === 'Owner' ? styles.disabledButton : ''}`} disabled={props.item.type === 'Owner'} onClick={handleButtonClick}>
                {props.buttonTitle}
            </button>
        </div>
    )
})

export default ListItem;
